<template>
  <Disclosure as="template" v-slot="{ open }">
    <li
      class="eds-details"
      :class="[containerClass, { 'details-open': open }]"
      :style="[containerStyle]"
    >
      <DisclosureButton
        class="details-summary"
        :class="[buttonClass]"
        :style="[buttonStyle]"
      >
        <span> {{ label }} </span>
      </DisclosureButton>
      <DisclosurePanel
        class="details-container"
        :class="[panelClass]"
        :style="[panelStyle]"
      >
        <div
          class="details-content"
          :class="[contentClass]"
          :style="[contentStyle]"
        >
          <slot name="content" />
        </div>
      </DisclosurePanel>
    </li>
  </Disclosure>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
  } from '@headlessui/vue';

  export default defineComponent({
    name: 'AccordionDetails',
    props: {
      label: {
        type: String,
        required: false,
        default: '',
      },
      containerClass: {
        type: String,
        required: false,
        default: '',
      },
      containerStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      buttonClass: {
        type: String,
        required: false,
        default: '',
      },
      buttonStyle: {
        type: Object,
        required: false,
      },
      panelClass: {
        type: String,
        required: false,
        default: '',
      },
      panelStyle: {
        type: Object,
        required: false,
      },
      contentClass: {
        type: String,
        required: false,
        default: '',
      },
      contentStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
    components: {
      Disclosure,
      DisclosureButton,
      DisclosurePanel,
    },
  });
</script>
